import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import Typography from '@hellodarwin/core/lib/components/common/typography';
import { useTheme } from 'styled-components';
import { FooterRowDateContainer, FooterRowDateRow } from './styles';
const FooterRowDate = ({ Icon, label, date }) => {
    const theme = useTheme();
    return (_jsxs(FooterRowDateContainer, { children: [_jsxs(FooterRowDateRow, { children: [_jsx(Icon, { size: 16 }), _jsx(Typography, { elementTheme: "overline", color: theme.colors.grey_2, children: label })] }), _jsx(Typography, { elementTheme: "body3", color: theme.colors.grey_1, style: { paddingLeft: '24px' }, children: date })] }));
};
export default FooterRowDate;
